import Vue from 'vue'
import { Message } from 'element-ui'
import ElementUI from 'element-ui'
import './styles/element-variables.scss'
import './styles/global.scss'
import App from './App.vue'
import router from './router'
import store from './store'
import eventBus from '@/utils/eventBus'
import MaterialUpload from '@/components/MaterialUpload/index.vue'

Vue.use(ElementUI)

// 统一的上传组件（单图 / 多图 / 文件 + 素材库选择），各板块直接使用 <material-upload>
Vue.component('MaterialUpload', MaterialUpload)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  created() {
    eventBus.$on('auth:unauthorized', () => {
      store.commit('CLEAR_SESSION')
      if (router.currentRoute.name === 'Login') return
      Message.warning('登录已过期或未登录，请重新登录')
      const { fullPath } = router.currentRoute
      router.replace({
        name: 'Login',
        query: fullPath && fullPath !== '/login' ? { redirect: fullPath } : undefined
      })
    })
  },
  render: (h) => h(App)
}).$mount('#app')
